/* global System */

export default {
  Breadcrumb: () =>
    System.import(/* webpackChunkName: "Breadcrumb" */ './index'),
}
